import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import CoreComponent from "./CoreComponent";
import HolderModal from "../components/HolderModal";
import { connect } from "react-redux";
import { arrayToFormData } from "../utils/functions";
import { addIds } from "../actions/payment";
import { toast } from "react-toastify";
import { IUser, IHolder } from "../interfaces";

interface IState {
    models: any[],
    isLoading: boolean,
    matrix: any
}

class CreatePayments extends CoreComponent<any, any> {
    state: IState = {
        models: [],
        isLoading: true,
        matrix: []
    }

    constructor(props: any) {
        super(props);
    }

    async componentWillMount() {
        if (this.props.match.params.id) {
            this.restore(this.props.match.params.id);
        } else {
            if (this.props.payment.length == 0) {
                toast("Выберите партенов", { type: 'error' });
                this.props.history.push("/admin/holders");
            } else {
                this.models();
            }
        }
    }

    async models() {
        this.setState({
            isLoading: true,
        }, async () => {
            let url = `${config.api}/uploads/create-payment`;

            let res = await Axios.post(url, arrayToFormData({ ids: this.props.payment }));

            let matrix = [];

            if (res.data.models.length > 0) {

                for (let i = 0; i < res.data.models.length; i++) {
                    let user: IHolder = res.data.models[i];

                    let billing: string = (user.profile && user.profile.billing_last ? user.profile.billing_last + " " : "")
                        + (user.profile && user.profile.billing_first ? user.profile.billing_first + ' ' : "")
                        + (user.profile && user.profile.billing_middle ? user.profile.billing_middle + '' : "");

                    billing += billing != "" ? ', ' : "";

                    billing = billing + (user.billingCountryName ? user.billingCountryName + ', ' : "");
                    billing = billing + (user.profile && user.profile.billing_city ? user.profile.billing_city + '' : "");

                    matrix.push([
                        user.full_name?.trim(),
                        billing?.trim(),
                        user.balance,
                        user.profile?.billing_phone?.trim(),
                    ]);
                }
            }

            if (!this.isUnmounted) {
                this.setState({
                    models: res.data.models,
                    matrix,
                    isLoading: false
                })
            }
        })
    }

    async restore(id: number) {
        this.setState({
            isLoading: true,
        }, async () => {
            let url = `${config.api}/uploads/restore-payment`;

            let res = await Axios.post(url, arrayToFormData({ id }));
            if (!this.isUnmounted) {
                this.setState({
                    matrix: res.data.matrix,
                    isLoading: false
                })
            }
        })
    }

    async export() {
        if (this.state.matrix.length > 0) {
            let data = arrayToFormData({ matrix: this.state.matrix });
            let response: AxiosResponse = await Axios.post(`${config.api}/uploads/payment-export`, data, { responseType: "blob" });

            const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/vnd.ms-excel" }));
            const link = document.createElement('a');

            link.href = url;

            link.setAttribute('download', 'Экспорт вывод оплаты' + '.xlsx'); //or any other extension

            document.body.appendChild(link);

            link.click();
            link.remove();
        } else {
            toast("Выберите партнеров", { type: "error" });
        }
    }

    async savePayment() {
        if (this.state.matrix.length > 0) {
            let data = arrayToFormData({ matrix: this.state.matrix, id: this.props.match.params.id });
            let response: AxiosResponse = await Axios.post(`${config.api}/uploads/save-payment`, data);

            if (response.data.status == "success") {
                toast("Успешно сохранён.", { type: "success" });
            } else
                toast("Ошибка сервера.", { type: "error" });
        } else {
            toast("Выберите партнеров", { type: "error" });
        }
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="crm-holders">
                <div className="wrapper">
                    <NavLink className="crm-holders__back" to={!this.props.match.params.id ? "/admin/holders" : "/admin/reports/saved"}>
                        Назад
                    </NavLink>
                    <span className="crm-holders__title">Вывод оплаты</span>
                    <div className="crm-holders__headline">
                        <div className="crm-holders__buttons">
                            <a className="crm-button" role="button" onClick={() => {
                                this.savePayment();
                            }}>
                                Сохранить
                            </a>
                            <a className="crm-button" role="button" onClick={() => {
                                this.export();
                            }}>
                                Экспорт
                            </a>
                        </div>
                    </div>

                    <div className="crm-list">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <a role="button">
                                            Получатель
                                        </a>
                                    </th>
                                    <th>
                                        <a role="button">
                                            ФИО получателя
                                        </a>
                                    </th>
                                    <th>
                                        <a role="button">
                                            Остаток $
                                        </a>
                                    </th>
                                    <th>
                                        <a role="button">
                                            Телефон
                                        </a>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {!this.state.isLoading && this.state.matrix.length == 0 && <tr><td colSpan={8}>{t("Ничего не найдено")}</td></tr>}
                                {this.state.isLoading && <tr><td colSpan={8}>{t("Загрузка данных")}</td></tr>}
                                {this.state.matrix.map((data: any, i: number) => {
                                    return <tr key={i}>

                                        <td className="p-0 border"><input value={data[0]} className="w-99 p-2" onChange={(e: any) => {
                                            this.setState({
                                                matrix: this.state.matrix.map((d: any, index: number) => {
                                                    let newD = [...d];
                                                    newD[0] = e.target.value;
                                                    return index == i ? newD : d;
                                                })
                                            })
                                        }} /></td>
                                        <td className="p-0 border"><input value={data[1]} className="w-99 p-2" onChange={(e: any) => {
                                            this.setState({
                                                matrix: this.state.matrix.map((d: any, index: number) => {
                                                    let newD = [...d];
                                                    newD[1] = e.target.value;
                                                    return index == i ? newD : d;
                                                })
                                            })
                                        }} /></td>
                                        <td className="p-0 border"><input value={data[2]} className="w-99 p-2" onChange={(e: any) => {
                                            this.setState({
                                                matrix: this.state.matrix.map((d: any, index: number) => {
                                                    let newD = [...d];
                                                    newD[2] = e.target.value;
                                                    return index == i ? newD : d;
                                                })
                                            })
                                        }} /></td>
                                        <td className="p-0 border"><input value={data[3]} className="w-99 p-2" onChange={(e: any) => {
                                            this.setState({
                                                matrix: this.state.matrix.map((d: any, index: number) => {
                                                    let newD = [...d];
                                                    newD[3] = e.target.value;
                                                    return index == i ? newD : d;
                                                })
                                            })
                                        }} /></td>

                                    </tr>;
                                })}

                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth,
        payment: state.payment
    };
})(withTranslation()(CreatePayments));
